<template lang="pug">
.form-input-standard-user-send-documents-function.w-100
  .content.d-flex.flex-row.align-items-center
    span.error-message 詳細設定は文書送付を使用可にしないと有効になりません。

  //- 文書種類の編集の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getFunctionName("useEdit") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useEdit")
  //- テンプレートの使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getFunctionName("useTemplate") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useTemplate")
  //- 一時保存の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getFunctionName("useDraft") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useDraft")
  //- 送信・公開・非公開・削除の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getFunctionName("useControl") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useControl")
  //- 宛先種別（家族全員）の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getFunctionName("showTargetToAllFamily") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.showTargetToAllFamily")
  //- 宛先種別（家族個別）の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getFunctionName("showTargetToFamily") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.showTargetToFamily")
  //- 宛先種別（施設関係者個別）の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getFunctionName("showTargetToOtherUser") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.showTargetToOtherUser")
  //- 宛先種別（グループ：宛先グループ（家族））の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getFunctionName("showTargetToFamilySendMessageGroup") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.showTargetToFamilySendMessageGroup")
  //- 宛先種別（グループ：宛先グループ（施設関係者））の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getFunctionName("showTargetToOtherUserSendMessageGroup") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.showTargetToOtherUserSendMessageGroup")
  //- 宛先種別（グループ：利用者グループ）の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getFunctionName("showTargetToResidentGroup") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.showTargetToResidentGroup")
  //- 宛先種別（グループ：施設関係者グループ）の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getFunctionName("showTargetToOtherUserGroup") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.showTargetToOtherUserGroup")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { SendDocumentsFunction, sendDocumentsFunctionNameMap } from "@/commons/services/Authorization";

import UsableFunctionSwitch from "@/pc/basics/UsableFunctionSwitch.vue";

/**
 * ### 一般ユーザーの使用機能選択コンポーネント(待機者サービス、受信メッセージ)
 */
@Component({
  components: {
    UsableFunctionSwitch
  }
})
export default class FormInputStandardUserSendDocumentsFunction extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop()
  value!: SendDocumentsFunction;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): SendDocumentsFunction {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: SendDocumentsFunction) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * ### メッセージ送信の項目名を返す
   */
  public getFunctionName(functionKeyName: string): string {
    const functionName: string | undefined = sendDocumentsFunctionNameMap.get(functionKeyName);
    return functionName ? functionName : "";
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.form-input-standard-user-send-documents-function {
  margin-bottom: 12px;
  padding: 12px 12px 4px 12px;

  background-color: $hitomeq-gray;

  .content {
    margin-bottom: 8px;
    padding-right: 74px;

    .function-detail-name {
      margin-left: 16px;
    }
  }
}
</style>
